import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import auth0Client from '../Auth0';
import useUsersApi from '../hooks/useUsersApi';
import { getAppRedirectRoute } from 'on_web/helpers/redirectHelper';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

import { ROUTE_LANDING_PAGE } from 'routes';

export default function Auth0CallbackPage(props) {
  const [
    { response, loading, getUserData, responseProfile, getProfile },
  ] = useUsersApi();

  /**
   * State which will hold querystring passed to us from the app's landing page.
   */
  const [passedQs, setPassedQs] = useState(null);

  const goToLanding = () => {
    if (passedQs == null || passedQs === '') {
      props.history.push(ROUTE_LANDING_PAGE);
    } else {
      props.history.push(`${ROUTE_LANDING_PAGE}/${passedQs}`);
    }
  };

  const getGoToRoute = () => {
    const route = getAppRedirectRoute(
      'spare',
      response.user_metadata,
      responseProfile
    );
    if (passedQs == null || passedQs === '') {
      return route;
    } else {
      return `${route}/${passedQs}`;
    }
  };

  useEffect(() => {
    auth0Client
      .handleAuthentication()
      .then(authRes => {
        if (
          authRes != null &&
          authRes.appState != null &&
          authRes.appState.qs != null
        ) {
          // if state is passed to us from Auth0 (e.g. landing page set it) and 'qs' (querystring) prop is set, put it in state
          setPassedQs(authRes.appState.qs);
        }
        window.localStorage.setItem(
          'access_token',
          auth0Client.getAccessToken()
        );

        if (auth0Client.isAuthenticated()) {
          let auth0Profile = auth0Client.getProfile();
          auth0Profile &&
            auth0Profile.email &&
            window.localStorage.setItem('email_address', auth0Profile.email);

          getUserData()
            .then(() => {
              trackEvent('Signed up', 'User signed up');
              return getProfile();
            })
            .then(() => {})
            .catch(() => {
              window.localStorage.removeItem('access_token');
              goToLanding();
            });
        } else {
          window.localStorage.removeItem('access_token');
          goToLanding();
        }
      })
      .catch(err => {
        console.log(err);
        if (err == null) {
          goToLanding();
        }
      });
  }, []);

  // if response from hook is known, check where to redirect the user based on user_metadata
  if (response && response.user_metadata && responseProfile) {
    return <Redirect to={getGoToRoute()} />;
  } else {
    return <div>{loading && <div>Validating authentication...</div>}</div>;
  }
}
